import { useEffect } from 'react'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import type { TrackingEventValue } from '../../model/monitoring'
import type { GiftCardPromoTrackingProperties } from '../../state'

const loggedViews = new Set<string>()

export const useLogGiftCardPromoViewOnce = (eventName: TrackingEventValue, properties: GiftCardPromoTrackingProperties | null): void => {
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const offerPromoCode = properties?.offerPromoCode
  const giftCardOfferCampaignKey = properties?.giftCardOfferCampaignKey
  const isVisible = properties !== null

  useEffect(() => {
    if (!isVisible) {
      return
    }
    const key = JSON.stringify([eventName, offerPromoCode, giftCardOfferCampaignKey])
    if (loggedViews.has(key)) {
      return
    }
    loggedViews.add(key)
    try {
      logEvent(eventName, {
        ...(offerPromoCode !== undefined && { offerPromoCode }),
        ...(giftCardOfferCampaignKey !== undefined && { giftCardOfferCampaignKey }),
      })
    } catch {
      return
    }
  }, [eventName, isVisible, offerPromoCode, giftCardOfferCampaignKey, logEvent])
}
